export const HamiSlideBackgroundGradient =
  'bg-[rgb(39,20,135)] bg-gradient-to-br from-[rgba(39,20,135,1)] to-[rgba(40,183,187,1)] contrast-[160%] saturate-[70%]';
